import request from '@/utils/request'
export function getOfflineList(params) {
  return request({
    method: "get",
    url: "/dashboard/superviser/offline/list",
    params,
  })
}
export function getStopList(params) {
  return request({
    method: "get",
    url: "/dashboard/superviser/stop/list",
    params,
  })
}

/**
 * 空调告警历史
 * @param {object} params
 * @param {string} params.uuid 设备UUID
 * @param {string} params.alarmWindowValue 告警中文名(模糊查询)
 * @param {string} params.startTime 开始时间，格式为yyyy-MM-dd HH:mm:ss
 * @param {string} params.endTime 结束时间，格式为yyyy-MM-dd HH:mm:ss
 * @param {number} params.pageNum 页码
 * @param {number} params.pageSize 每页条数
 * @returns
 */
export function getAirconditionAlarmList(params) {
  return request({
    url: '/dashboard/airconditionAlarm/list',
    method: 'get',
    params: params
  })
}
